import { Component } from 'react';
import _ from 'lodash';
import ArrowLink from 'components/atoms/arrowLink';

import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class RadioButton extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleGroupOnChange() {
    let {
      fieldValue,
      group,
      input: { value, onChange },
    } = this.props;

    const newValue = value ? [...value] : [];
    const sibling = _.find(newValue, { [group]: fieldValue[group] });

    if (sibling) {
      newValue.splice(newValue.indexOf(sibling), 1);
    }

    if (sibling !== fieldValue) {
      newValue.push(fieldValue);
    }

    onChange(newValue);
  }

  handleOnChange() {
    let {
      fieldValue,
      toggleValue,
      group,
      input: { value, onChange },
    } = this.props;

    if (group) {
      return this.handleGroupOnChange();
    }

    toggleValue = toggleValue || null;

    const newValue = value === fieldValue ? toggleValue : fieldValue;

    onChange(newValue);
  }

  isChecked() {
    const {
      fieldValue,
      group,
      input: { value },
    } = this.props;

    if (group) {
      const values = value || [];

      return !!_.find(values, fieldValue);
    }

    let expectedValue = typeof value === 'object' ? value.id : value;
    let currentValue = typeof fieldValue === 'object' ? fieldValue.id : fieldValue;

    return expectedValue === currentValue;
  }

  render() {
    const {
      children,
      link,
      linkOnClick,
      imageFile,
    } = this.props;

    const checked = this.isChecked();

    let linkContent;
    if (link) {
      linkContent = (
        <div className="link">
          <ArrowLink size="small" onClick={linkOnClick}>
            {link}
          </ArrowLink>
        </div>
      );
    }

    let imageContent;
    if (imageFile) {
      imageContent = (
        <div className="radioImage">
          <img src={require(`resources/img/${imageFile}`)} />
        </div>
      );
    }

    let className = cx({
      radioButton: true,
      block: this.props.block,
      inline: this.props.inline,
      bordered: this.props.bordered,
      withImage: this.props.withImage,
    });

    return (
      <div className={classnames(className)}>
        <input type="radio" onChange={this.handleOnChange.bind(this)} checked={checked} />

        <div className="radioButtonInput">
          <div className="radioButtonInputCheck" />
        </div>
        {imageContent}
        <div className="radioButtonLabel">{children}</div>

        {linkContent}
      </div>
    );
  }
}
